import { useUser } from "src/contexts/user-context";

/**
 * Shared gate for one-time "new feature" announcement modals. These are
 * suppressed while a staff member is impersonating a workspace so we don't
 * dismiss a customer's announcement on their behalf and to avoid stacking a
 * modal over the impersonated content.
 *
 * Announcement modals consume this hook in their own `useShouldShow*` gating
 * logic so that both rendering and impression analytics ("Shown") are
 * suppressed during impersonation.
 */
export const useShouldSuppressFeatureAnnouncements = (): boolean => {
  const { user } = useUser();
  return Boolean(user?.is_impersonating);
};
